import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormattedAmountPipe } from './formatted-amount.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [FormattedAmountPipe],
  exports: [FormattedAmountPipe]
})
export class FormattedAmountPipeModule {}
